export function ContentIcon() {
    return (
        <svg width='20' height='20' viewBox='0 0 20 20'>
            <path
                d='M17 6v12c0 .52-.2 1-1 1H4c-.7 0-1-.33-1-1V2c0-.55.42-1 1-1h8l5 5zM14 8h-3.13c-.51 0-.87-.34-.87-.87V4'
                stroke='currentColor'
                fill='none'
                fillRule='evenodd'
                strokeLinejoin='round'
            />
        </svg>
    );
}
